import PublicationJobsAddressLists from "./PublicationJobsAddressLists";

export default class StorePromosAddressLists extends PublicationJobsAddressLists {
}
